import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { type User } from '@avanta/shared/types/users';
import { useTranslation } from 'react-i18next';
import { useCoupons } from 'hooks/useFetchCoupons';
import { SessionsListItem } from './SessionsListItem';

export const RemainingSessions = ({ patient }: { patient: User }): React.ReactElement | null => {
  const { remainingSessionsThisMonth, couponsCount, enterpriseSessions } = useCoupons(patient?.id);
  const { t } = useTranslation(LOCIZE_NS.CHAT);

  const isInfinite = remainingSessionsThisMonth === Infinity;
  const sessionsItems: { label: string; value: number | string }[] = [];

  if (isInfinite) {
    sessionsItems.push({
      label: t('Chat.UserInfo.RemainingSessions.PAE'),
      value: t('Chat.UserInfo.RemainingSessions.unlimited'),
    });
  } else if (remainingSessionsThisMonth && !enterpriseSessions) {
    sessionsItems.push({
      label: t('Chat.UserInfo.RemainingSessions.PAE'),
      value: remainingSessionsThisMonth,
    });
  }

  if (enterpriseSessions && !isInfinite) {
    sessionsItems.push({
      label: t('Chat.UserInfo.enterpriseSessions.label'),
      value: enterpriseSessions,
    });
  }

  Object.entries(couponsCount).forEach(([speciality, count]) => {
    sessionsItems.push({
      label: t(`Chat.UserInfo.RemainingSessions.${speciality}`),
      value: count,
    });
  });

  if (sessionsItems.length === 0) return null;

  return (
    <>
      <h3 className="text-lg font-medium">{t('Chat.UserInfo.Coupons.heading')}</h3>
      <ul className="list-disc list-outside pl-5 space-y-1 marker:text-gray-500 text-sm text-gray-600">
        {sessionsItems.map(({ label, value }) => (
          <div key={label}>
            <SessionsListItem label={label} value={value} />
          </div>
        ))}
      </ul>
    </>
  );
};
